export default "fe57dcba61ecd85a.svg"